<template>
  <div class="expense_type_compare">
    <template-form title="การหักค่าใช้จ่าย" description="">
      <div class="etcb-title">
        <div class="etcbt-wrapper">
          <div>
            ในการคำนวณภาษีของบุคคลธรรมดา สามารถเลือก รูปแบบการหักค่าใช้จ่ายได้ 2
            แบบ คือแบบหักเหมา และแบบหักตามจริงลองเลือกแบบที่เหมาะกับคุณ
          </div>
          <chevron-right-link
            class="diff"
            @clickLink="goDefinition"
            caption="ต่างกันอย่างไร"
          />
        </div>
      </div>
      <div class="etc-body">
        <div class="etcb-header">
          <div
            class="etcbh-left"
            @click="switchType('charter')"
            :class="[isCharter ? 'etcbh-active' : '']"
          >
            <div class="etcbh-block">
              <img v-if="isCharter" :src="CHECKPRIMARY1" alt="check-primary1" />
            </div>
            <h4>หักเหมา</h4>
          </div>
          <div
            class="etcbh-right"
            @click="switchType('real')"
            :class="[!isCharter ? 'etcbh-active' : '']"
          >
            <div class="etcbh-block">
              <img
                v-if="!isCharter"
                :src="CHECKPRIMARY1"
                alt="check-primary1"
              />
            </div>
            <h4>หักตามจริง</h4>
          </div>

          <div class="ab-bg-lightblue">
            <div
              class="bg-lightblue"
              :class="[isCharter ? 'focus-with-vat' : '']"
              style="margin-right: 7px;"
            />
            <div
              class="bg-lightblue"
              :class="[!isCharter ? 'focus-with-vat' : '']"
              style="margin-left: 7px;"
            />
          </div>
        </div>

        <div class="etcb-row">
          <div class="etcbr-topic">{{ incomeLable }}</div>
          <div class="etcbr-detail">
            <div
              class="etcbrd-left"
              :class="[isCharter ? 'etcbrd-text-bold' : '']"
            >
              <currency mode="readOnly" :value="charter.totalIncome" />
            </div>
            <div
              class="etcbrd-right"
              :class="[!isCharter ? 'etcbrd-text-bold' : '']"
            >
              <currency mode="readOnly" :value="real.totalIncome" />
            </div>
          </div>
        </div>

        <div class="etcb-row">
          <div class="etcbr-topic">{{ costLable }}</div>
          <div class="etcbr-detail">
            <div
              class="etcbrd-left"
              :class="[isCharter ? 'etcbrd-text-bold' : '']"
            >
              <currency mode="readOnly" :value="charter.totalExpense" />
            </div>
            <div
              class="etcbrd-right"
              :class="[!isCharter ? 'etcbrd-text-bold' : '']"
              style="display: flex;"
            >
              <currency mode="readOnly" :value="real.totalExpense" /><span
                v-if="isTaxCharter"
                >*</span
              >
            </div>
          </div>
        </div>

        <div class="etcb-row">
          <div class="etcbr-topic">อัตราภาษี</div>
          <div class="etcbr-detail">
            <div
              class="etcbrd-left"
              :class="[isCharter ? 'etcbrd-text-bold' : '']"
            >
              {{ charter.maxTaxRate * 100 }}%
            </div>
            <div
              class="etcbrd-right"
              :class="[!isCharter ? 'etcbrd-text-bold' : '']"
            >
              {{ real.maxTaxRate * 100 }}%
            </div>
          </div>
        </div>

        <div class="etcb-row">
          <div class="etcbr-topic">ค่าภาษี</div>
          <div class="etcbr-detail">
            <div
              class="etcbrd-left"
              :class="[isCharter ? 'etcbrd-text-bold' : '']"
            >
              <currency mode="readOnly" :value="charter.tax" />
            </div>
            <div
              class="etcbrd-right"
              :class="[!isCharter ? 'etcbrd-text-bold' : '']"
            >
              <currency mode="readOnly" :value="real.tax" />
            </div>
          </div>
        </div>
        <div style="text-align: left; padding: 20px;" v-if="isTaxCharter">
          * จากการคำนวณภาษี คุณอยู่ในเกณฑ์จ่ายภาษีแบบ
          <span class="red bold">หักภาษีเหมา 0.5% จากรายได้</span>
          ดังนั้นจึงไม่สามารถ หักค่าใช้จ่ายได้
        </div>
        <div class="etcb-status">
          <img
            v-if="isCharter"
            class="etcbs-background"
            :src="isPayCharterLess ? BACKGROUNDSUCCESS : BACKGROUNDERROR"
            alt="background-success"
          />
          <img
            v-else
            class="etcbs-background"
            :src="!isPayCharterLess ? BACKGROUNDSUCCESS : BACKGROUNDERROR"
            alt="background-success"
          />

          <div class="etcbs-text" v-if="isCharter">
            <h4 v-if="isPayCharterLess">หักเหมาจะเสียภาษีน้อยกว่า</h4>
            <h4 v-else>หักเหมาจะเสียภาษีมากกว่า</h4>
            <h1><currency mode="readOnly" :value="diffValue" /></h1>
          </div>
          <div class="etcbs-text" v-else>
            <h4 v-if="!isPayCharterLess">หักตามจริงจะเสียภาษีน้อยกว่า</h4>
            <h4 v-else>หักตามจริงจะเสียภาษีมากกว่า</h4>
            <h1><currency mode="readOnly" :value="diffValue" /></h1>
          </div>
        </div>

        <div class="etcb-detail">
          นอกจากนี้บุคคลธรรมดายังสามารถลดภาษี <br class="is-desktop" />
          ด้วยค่าใช้จ่ายบางประเภทได้อีกด้วย
        </div>

        <material-button class="etcb-button" @clickButton="goToDeduct">
          กรอกค่าลดหย่อน
        </material-button>
      </div>
    </template-form>
  </div>
</template>

<script>
import CHECKPRIMARY1 from "@/assets/icons/check-primary1.svg";
import BACKGROUNDSUCCESS from "@/assets/icons/background-success.svg";
import BACKGROUNDERROR from "@/assets/icons/background-error.svg";

export default {
  name: "ExpenseTypeCompare",
  components: {},
  computed: {
    isTaxCharter: function () {
      return this.$store.getters["taxInfo/getTaxCharter"];
    },
  },
  data() {
    const { charter, real } = this.$store.getters[
      "taxInfo/taxExpenseDeductionInfo"
    ];
    const isPayCharterLess = charter.tax - real.tax < 0;
    const diffValue = Math.abs(charter.tax - real.tax);
    const isRegisteredVat = this.$store.getters["questions/getAnswers"]
      .isRegisteredVat;
    const goodsType = this.$store.getters["questions/getAnswers"].goodsType;

    let incomeLable = isRegisteredVat ? "รายได้ต่อปี  " : "รายได้ต่อปี";
    let costLable =
      isRegisteredVat && goodsType ? "ค่าใช้จ่ายต่อปี " : "ค่าใช้จ่ายต่อปี";
    const isCharter = this.$store.getters["taxInfo/getCharter"];

    return {
      isCharter,
      CHECKPRIMARY1,
      charter,
      real,
      diffValue,
      isPayCharterLess,
      BACKGROUNDSUCCESS,
      BACKGROUNDERROR,
      incomeLable,
      costLable,
    };
  },
  methods: {
    getUserTopics() {
      return this.taxExpenseDeductionInfo();
    },
    switchType(value) {
      this.isCharter = value === "charter";
      this.$store.dispatch("taxInfo/addIncomeValue", {
        name: "charter",
        value: value === "charter",
      });
    },
    goToDeduct() {
      this.$router.push({
        path: "/forms/deduct",
      });
    },
    goDefinition() {
      this.$router.push({
        path: "/info/expense_type_definition",
      });
    },
  },
};
</script>

<style scoped>
.expense_type_compare {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.layout {
  width: 100%;
  padding: 0px 30px;
  max-width: 1120px;
  box-sizing: border-box;
}
.etc-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 544px;
  text-align: center;
  position: relative;
  margin-bottom: 26px;
}
.bold {
  font-weight: bold;
}
.red {
  color: #f45a49;
}
.etcb-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 16px;
  text-align: left;
  padding: 0px 30px;
  box-sizing: border-box;
}
.etcbt-wrapper .crl-link {
  margin-top: 8px;
}
.etcb-header {
  width: 100%;
  display: flex;
  height: 56px;
  margin-bottom: 16px;
  position: relative;
}

.ab-bg-lightblue {
  position: absolute;
  top: 56px;
  width: 100%;
  height: 340px;
  display: flex;
  justify-content: space-between;
}

.bg-lightblue {
  flex: 1;
  max-width: 265px;
}
.focus-with-vat {
  background: #99d6f1;
  opacity: 0.1;
}

.etcbh-block {
  width: 24px;
  height: 24px;
  background: #ffffff;
  margin-right: 16px;
  border-radius: 2px;
}
.etcbh-left {
  flex: 1;
  background: #acb1bf;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 7px;
  color: #ffffff;
}
.etcbh-right {
  flex: 1;
  background: #acb1bf;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 7px;
  color: #ffffff;
}
.etcbh-active {
  background: #29a9e2;
}

.etcb-row {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 24px;
  padding: 0px 24px;
  box-sizing: border-box;
  background: transparent;
}
.etcbr-topic {
  width: 100%;
  display: flex;
  align-items: center;
  text-align: left;
  color: #acb1bf;
  border-bottom: 1px solid #d8d9e0;
  margin-bottom: 8px;
  background: transparent;
}
.etcbr-detail {
  width: 100%;
  display: flex;
}
.etcbr-detail > div {
  flex: 1;
  text-align: right;
  padding-right: 30px;
}

.etcbrd-text-bold input,
.etcbrd-text-bold {
  font-weight: bold;
}
.currency_input {
  text-decoration: none;
  color: #393d43;
}
.etcbrd-link {
  text-decoration: underline;
  color: #29a9e2;
}

.etcb-status {
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 239px;
  margin-top: 34px;
  margin-bottom: 31px;
}
.etcbs-background {
  position: absolute;
  z-index: -1;
  height: 239px;
  width: 308px;
}
.etcbs-text {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #ffffff;
}
.etcb-detail {
  width: 100%;
  color: #393d43;
  margin-bottom: 24px;
  text-align: left;
  display: flex;
  justify-content: center;
}
.etcbs-text input {
  color: white;
  text-align: center;
}
.etcb-button {
  max-width: 352px;
  margin-bottom: 14px;
}
.back-button {
  margin: 24px 0;
}
.diff {
  justify-content: center;
}
/*size  >768px */
@media only screen and (min-width: 769px) {
  .etc-body {
    margin-top: 0;
  }
  .etcb-row {
    padding: 0px;
  }
  .etcbh-left,
  .etcbh-right {
    padding: 0px 24px;
    justify-content: flex-start;
  }
  .etcbrd-left,
  .etcbrd-right {
    max-width: 232px;
    max-width: 256px;
    margin-right: 0px;
    margin-left: 0px;
  }

  .is-desktop {
    display: none;
  }
  .layout {
    padding: 0;
  }
  .back-button {
    margin-bottom: 0;
  }
  .etcbr-topic {
    padding: 0px 30px;
    box-sizing: border-box;
  }
}
</style>
